<template>
  <div id="app">
    <router-view/>
    <vue-footer></vue-footer>
  </div>
</template>

<script>
import VueFooter from '@/components/Footer'

export default {
  name: 'app',
  components: {
    VueFooter
  }
}
</script>

<style>
#app {
  font-family: Arial, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 12px;
  margin: 5% 2% 0;
}
@media (min-width: 768px) {
  #app {
    font-size: 12px;
    margin: 28px 12px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue